// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetContactResponse

export type WidgetContactApiResponse = {
	address: string | null;
	useOwnerContact: boolean;
	contactName: string | null;
	contactPhone: string | null;
	contactEmail: string | null;
};

export type WidgetContact = {
	address: string | null;
	useOwnerContact: boolean;
	contactName: string | null;
	contactPhone: string | null;
	contactEmail: string | null;
};

export function hydrateWidgetContact(data: WidgetContactApiResponse): WidgetContact {
	return { ...data };
}